<template>
  <div class="floating-task-bar" ref="floatingTaskBarRef" :style="taskbarStyle">
    <div
      v-if="isPopOverVisible"
      id="workflowTaskBar"
      v-click-outside="hideTaskbar"
    >
      <WorkFlowTaskBar
        ref="WorkFlowTaskBarRef"
        :process="process"
        :tasksArray="tasksArray"
        :tasksMiscData="tasksMiscData"
        :isUserHasAccess="isUserHasAccess"
        :customTasksList="customTasksList"
        :isFloating="true"
        :currentTaskId="currentTaskId"
        :taskInsertDirection="taskInsertDirection"
        :workFlowTaskBarHeight="workFlowTaskBarHeight"
        @onClose="hideTaskbar"
        @setTaskbarMode="(el) => $emit('setTaskbarMode', el)"
        @onCustomTaskActionTrigger="
          (action, task) => $emit('onCustomTaskActionTrigger', action, task)
        "
      />
    </div>
  </div>
</template>

<script>
import WorkFlowTaskBar from './WorkFlowTaskBar.vue';

export default {
  name: 'WorkFlowFloatingTaskBar',
  data() {
    return {
      isPopOverVisible: false,
      workFlowTaskBarHeight: window.innerHeight / 2,
      dropdownBottomDistance: 0,
      taskbarStyle: {},
    };
  },
  props: {
    process: {
      type: Object,
      required: true,
    },
    tasksArray: {
      type: Array,
      required: true,
    },
    tasksMiscData: {
      type: Object,
      required: true,
    },
    isUserHasAccess: {
      type: Boolean,
      required: true,
      default: false,
    },
    customTasksList: {
      type: Array,
      required: true,
    },
    currentTaskId: {
      type: Number | String,
      required: false,
    },
    taskInsertDirection: {
      type: String,
      required: false,
    },
    scale: {
      type: Number,
      required: true,
    },
    coordinates: {
      type: Object,
      requried: true,
    },
  },
  methods: {
    hideTaskbar() {
      this.$emit('hide');
    },
    togglePopOver() {
      this.isPopOverVisible = !this.isPopOverVisible;
    },
    onPopOverClick() {
      const getCoordinates =
        this.$refs.floatingTaskBarRef.getBoundingClientRect();
      const centerVerticalPoint = window.innerHeight / 2;
      const centerYOfElement = getCoordinates.top + getCoordinates.height / 2;
      if (centerVerticalPoint > centerYOfElement) {
        this.workFlowTaskBarHeight =
          (window.innerHeight - getCoordinates.top - 50 * 1) / 1 + 35 * 1;
      } else {
        this.workFlowTaskBarHeight =
          (getCoordinates.bottom - 150) / this.scale + 55 * this.scale;
      }

      // set left right based on selection
      // 44 px for button width
      const buttonSize = 44 * this.scale;
      // 90 px for task
      const taskSize = 90 * this.scale;
      // 28 px for spacing between button and task
      const spacing = 28 * this.scale;
      const taskBarWidth = 346;
      if (
        // here +8 is the spacing between border or window and taskbar
        window.innerWidth - (taskBarWidth + 8) < this.coordinates.x &&
        ['right', 'bottom', 'top'].includes(this.taskInsertDirection)
      ) {
        this.taskbarStyle.left =
          this.coordinates.x - (spacing * 2 + taskSize + taskBarWidth) + 'px';
      } else if (
        this.coordinates.x - (taskBarWidth + 8 - buttonSize) <= 0 &&
        this.taskInsertDirection === 'left'
      ) {
        this.taskbarStyle.left =
          this.coordinates.x + buttonSize + taskSize + spacing * 2 + 'px';
      } else {
        if (this.taskInsertDirection === 'left') {
          this.taskbarStyle.left =
            this.coordinates.x - (taskBarWidth - buttonSize) + 'px';
        }
        // ['right', 'bottom', 'top'].includes(this.taskInsertDirection)
        else {
          this.taskbarStyle.left = this.coordinates.x + 'px';
        }
      }
      this.togglePopOver();
    },
  },
  mounted() {
    this.onPopOverClick();
  },
  components: {
    WorkFlowTaskBar,
  },
};
</script>

<style scoped>
.floating-task-bar {
  position: absolute;
  top: 88px;
}
</style>
